"use client";

import OverlayWrapper from "@/components/ui/OverLayWrapper";
import ProductEditor from "./ProductEditor";

export default function EditProductOverlay({
  onClose,
  ...props
}: {
  onClose: () => void;
  defaultProducer?: string;
  initialSlug?: string;
  focusPartNumber?: boolean;
}) {
  return (
    <OverlayWrapper
      dismissOnOverlay={false}
      onClose={onClose}
      snapPoints={["97vh"]}
      draggable={false}
    >
      <ProductEditor {...props} onClose={onClose} />
    </OverlayWrapper>
  );
}
